/* eslint-disable import/no-anonymous-default-export */
export default (tags = [], action) => {
    switch (action.type) {
        case 'SELECTED_TAG':
            return tags.filter((tag) => tag._id === action.payload );
        case 'DELETE_TAG':
            return tags.filter((tag) => tag._id !== action.payload );
        case 'UPDATE_TAG':
            return tags.map((tag) => tag._id === action.payload._id ? action.payload : tag );
        case 'FETCH_ALL_TAG':
            return action.payload;
        case 'CREATE_TAG':
            return [...tags, action.payload];
        default:
            return tags;
    }
}